import React from "react";
import {EntityTypeProfile} from "../../../common/enum";
import { useSelector } from "react-redux";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const ProfileCell = (props) => {
  const { translate } = useSelector((state) => state);

  const { t } = useTranslation();

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  let entityType =
    Object.keys(EntityTypeProfile)[
      Object.values(EntityTypeProfile).indexOf(props.dataItem.entity.entityType)
    ];

  return <td>{t(`${entityType}`)}</td>;
};

export default ProfileCell;
